import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import ExportTextContainer from '../ExportTextContainer';
import ExportText from '../ExportText';
import styles from '../../Dropdowns.scss';

const BASE_KEY = 'components.dropdowns.export.views.assets_selected';

function ExportAssetsSelected({
    allSelected,
    assetLimit,
    assetsSelected,
}) {
    let extraClassName;
    let emailNumber = assetsSelected;
    let largeMessageKey = 'selection.partial';
    let smallMessageKey = 'broad_or_narrow';
    const overLimit = assetsSelected > assetLimit;

    if (allSelected) {
        largeMessageKey = 'selection.all';
    }
    if (overLimit) {
        largeMessageKey = 'selection.over';
        smallMessageKey = 'narrow';
        emailNumber = assetsSelected - assetLimit;
        extraClassName = styles['warning-text'];
    }

    return (
        <div data-all-selected={allSelected} data-over-limit={overLimit}>
            <ExportTextContainer>
                <ExportText
                    messageKey={`${BASE_KEY}.${largeMessageKey}`}
                    size="large"
                    text={{
                        emailNumber: emailNumber.toLocaleString(),
                        extraClassName,
                    }}
                />
                <ExportText
                    messageKey={`${BASE_KEY}.${smallMessageKey}`}
                    size="small"
                />
            </ExportTextContainer>
        </div>
    );
}

ExportAssetsSelected.propTypes = {
    allSelected: PropTypes.bool.isRequired,
    assetLimit: PropTypes.number.isRequired,
    assetsSelected: PropTypes.number.isRequired,
};

ExportAssetsSelected.displayName = displayName('Dropdowns/ExportDropdownViews/AssetsSelected');

export default ExportAssetsSelected;
